import { portfolioPhotoData } from "../data/photoData"

export const getPortfolioPhotos = (portfolioId: string) => {
    return portfolioPhotoData[portfolioId as keyof typeof portfolioPhotoData] ?? []
}

export const getPortfolioPhotoById = (portfolioId: string, photoId: string) => {
    return getPortfolioPhotos(portfolioId).find(photo => photo.id === photoId)
}